export default __webpack_public_path__ + "static/media/jntu.2f4a284d.png";